import React from 'react';
import { useLocalize } from 'localize-react';
import { IJourney, JourneyStatusType } from '@transferz/fe-models';
import Typography from '@transferz/fe-component-library/src/components/typography/Typography';
import Circle from '@transferz/fe-component-library/src/components/icons/CircleIcon';

interface IBookingStatusProps {
  journey: IJourney;
  statuses?: any[];
  classes?: string;
}

export const BookingStatus: React.FC<IBookingStatusProps> = ({
  journey,
  statuses = [],
  classes = '',
}) => {
  const { translate } = useLocalize();

  return (
    <>
      {journey
        ? <div className={`booking-status ${classes}`}>
          <Circle
            width={16}
            color={(journey?.status !== JourneyStatusType.CancelledWithCosts && journey?.status !== JourneyStatusType.CancelledFree)
              ? 'atlantis5'
              : 'red5'} />
          <Typography
            variant="subtitle1"
            color={(journey?.status !== JourneyStatusType.CancelledWithCosts && journey?.status !== JourneyStatusType.CancelledFree)
              ? 'atlantis5'
              : 'red5'}>
            {translate(`journeyStatus_${Object.keys(statuses)?.length ? statuses[journey.id]?.status : journey?.status}`)}
          </Typography>
        </div>
        : null
      }
    </>
  );
};
